import Box from "@material-ui/core/Box";
import React, {useState} from "react";
import {Reveal} from "react-genie";
import {makeStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import gado from "../../assets/gado_chan.png";
import Grid from "@material-ui/core/Grid";
import LazyLoad from "react-lazyload";
import Lightbox from "react-image-lightbox";
import Link from "@material-ui/core/Link";

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "rgba(164,143,124, .9)",
        padding: theme.spacing(8, 0, 6),
    },
    imageBox: {
        width: "100%",
        display: "inline-block",
        position: "relative"
    },
    menuPickUpImage: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        [theme.breakpoints.up('md')]: {
            height: "550px"
        },
    },
}));
export default function Course(props) {
    const {spMatches} = props;
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);
    const handleClickImage = (props) => {
        setPhotoIndex(props);
        setOpen(true);
    };
    const images = [
        '/images/menu/course/2.jpg',
        '/images/menu/course/1.jpg',
    ];
    return (
        <div className={classes.root}>
            <Reveal>
                {open && (
                    <Lightbox
                        mainSrc={images[photoIndex]}
                        nextSrc={images[(photoIndex + 1) % images.length]}
                        prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                        onCloseRequest={() => setOpen(false)}
                        onMovePrevRequest={() =>
                            setPhotoIndex((photoIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setPhotoIndex((photoIndex + 1) % images.length)
                        }
                    />
                )}
                <Box fontSize={spMatches ? "h2.fontSize": "h2.fontSize"}>
                    <Typography variant="h3" component="h2" className="text-black text-bold en">
                        COURSE
                    </Typography>
                    <Typography variant={spMatches ? "subtitle1" : "h5"} component="h2" className="text-black text-bold en" >
                        コースメニュー
                    </Typography>
                </Box>
                <Box mt={1} p={spMatches ? 3 : 10}>
                    <Box display="flex">
                        <Grid container spacing={2} >
                            <Grid item xs={12} md={12}>
                                <div className={classes.imageBox}>
                                    <LazyLoad>
                                        <img src="/images/menu/course/2.jpg"
                                             alt="コース" className={classes.menuPickUpImage}
                                             onClick={() => {
                                                 handleClickImage(0);
                                             }}
                                        />
                                    </LazyLoad>
                                </div>
                                {/*<Box mt={2}>*/}
                                {/*    <Link*/}
                                {/*        href="https://tabelog.com/nagano/A2004/A200404/20018874/party/"*/}
                                {/*        target="_blank"*/}
                                {/*        className="tabelog-button"*/}
                                {/*    >*/}
                                {/*        <Typography variant="subtitle1"　className="text-bold en" >*/}
                                {/*            <span style={{ marginLeft: '1rem'}}>その他のコースは食べログへ。</span>*/}
                                {/*        </Typography>*/}
                                {/*    </Link>*/}
                                {/*</Box>*/}
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Reveal>
            {spMatches && (
                <Reveal delay={200} className="balloon5">
                    <div className="faceicon">
                        <img src={gado} className={spMatches ? "gadochan-sp" : "gadochan"}
                             alt="ガドガドのキャラクター" />
                    </div>
                    <div className="chatting">
                        <div className="says">
                            <p>飲み放題がとにかくお得❗</p>
                        </div>
                    </div>
                </Reveal>
            )}
        </div>
    )
}
